// React-imports
import { ReactElement, useEffect, useState } from "react";

// Style Imports
import "./something-wrong.scss";

const SomethingWrong: React.FC = (): ReactElement => {
  const [device, setDevice] = useState<string>("");

  useEffect(() => {
    if (navigator.userAgent.toLowerCase().includes("android")) {
      setDevice("android");
    } else if (/(iPad|iPhone|iPod)/.test(navigator.userAgent)) {
      setDevice("ios");
    } else {
      setDevice("pc");
    }
  }, []);

  return (
    <div className="flex flex-col something-wrong-container items-center min-h-screen">
      <div className="background"></div>
      <img src="./images/kamco-logo.png" alt="kamco invest" />
      <div className="white-container">
        <table>
          <tr>
            <td>
              <img src="./images/warning.svg" alt="kamco registeration-image" />
            </td>
          </tr>
          <tr>
            <td>
              <span>Oops! Something went wrong.</span>
            </td>
          </tr>
        </table>
        <span className="border"></span>
        <p className="first-p mb-7">
          It seems that we've encountered a problem. Please bear with us as we
          work to resolve the issue. If you need <br /> immediate assistance or
          have any concerns, feel free to contact our support team at
        </p>
        <p className="mb-3">
          <b>appsupport@kamcoinvest.com.</b>
        </p>
        <p className="mb-5">Thank you for your patience and understanding.</p>
        {device !== "pc" && (
          <button
            onClick={() => (window.location.href = "com.kamco.stage")}
            className="button"
          >
            Contact our support team
          </button>
        )}
      </div>
      <footer className=" flex flex-col mt-auto">
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/kamco-invest/"
            >
              <img src="./images/linkedin.svg" alt="kamco invest linkedin" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/kamcoinvest"
            >
              <img src="./images/facebook.svg" alt="kamco invest facebook" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/KamcoInvest"
            >
              <img src="./images/twitter.svg" alt="kamco twitter x" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/kamco_invest/?hl=en"
            >
              <img src="./images/instagram.svg" alt="kamco instagram" />
            </a>
          </li>
        </ul>
        <p className=" text-sm md:text-base">Copyright © 2024 Kamco Invest. All Rights Reserved</p>
      </footer>
    </div>
  );
};

export default SomethingWrong;
